export function htmlToPlainText(html) {
  if (html == null || html === '') return '';
  if (typeof html !== 'string') return String(html);
  if (typeof document === 'undefined') {
    return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  }
  const div = document.createElement('div');
  div.innerHTML = html;
  return (div.textContent || div.innerText || '').replace(/\s+/g, ' ').trim();
}

export function normalizeNoticeRecord(raw) {
  if (!raw || typeof raw !== 'object' || raw.id == null) return null;
  const audience = raw.audience === 'groups' ? 'groups' : 'all';
  const serviceGroupIds = Array.isArray(raw.serviceGroupIds)
    ? raw.serviceGroupIds.map(Number).filter((n) => !Number.isNaN(n))
    : [];
  const attachments = Array.isArray(raw.attachments) ? raw.attachments : [];
  const authorName = typeof raw.authorName === 'string' ? raw.authorName : '';
  const rawAid = raw.authorId;
  const authorId =
    rawAid != null && rawAid !== '' && !Number.isNaN(Number(rawAid)) ? Number(rawAid) : null;

  return {
    ...raw,
    audience,
    serviceGroupIds: audience === 'groups' ? serviceGroupIds : [],
    attachments,
    authorName,
    authorId,
  };
}

/** ID numérico do grupo do operador (campo plano ou relação `service_group`). */
export function getOperatorServiceGroupId(currentUser) {
  if (!currentUser) return NaN;
  const flat = currentUser.service_group_id;
  if (flat != null && flat !== '') {
    const n = Number(flat);
    if (!Number.isNaN(n)) return n;
  }
  const nested = currentUser.service_group?.id;
  if (nested != null && nested !== '') {
    const n = Number(nested);
    if (!Number.isNaN(n)) return n;
  }
  return NaN;
}

/** Operador comum: vê avisos "para todos" ou cujo grupo está na lista (filtro no cliente, se necessário). */
export function isNoticeVisibleToOperator(item, currentUser) {
  const normalized = normalizeNoticeRecord(item);
  if (!normalized) return false;
  if (normalized.audience !== 'groups') return true;
  const ids = normalized.serviceGroupIds;
  if (ids.length === 0) return false;
  const gid = getOperatorServiceGroupId(currentUser);
  if (Number.isNaN(gid)) return false;
  return ids.includes(gid);
}

export function buildServiceGroupLabelMap(serviceGroups) {
  const map = new Map();
  (serviceGroups || []).forEach((g) => {
    if (g && g.id != null) map.set(Number(g.id), g.description || String(g.id));
  });
  return map;
}

/** Texto curto para chip na lista. */
export function shortAudienceLabel(item, labelById) {
  const n = normalizeNoticeRecord(item);
  if (!n || n.audience !== 'groups') return 'Todos';
  const ids = n.serviceGroupIds;
  if (ids.length === 0) return 'Grupos';
  const first = labelById.get(ids[0]) || `#${ids[0]}`;
  if (ids.length === 1) return first;
  return `${first} +${ids.length - 1}`;
}

/** Texto completo para o painel de leitura. */
export function fullAudienceLabel(item, labelById) {
  const n = normalizeNoticeRecord(item);
  if (!n || n.audience !== 'groups') return 'Todos os departamentos';
  const ids = n.serviceGroupIds;
  if (ids.length === 0) return 'Nenhum departamento selecionado';
  return ids
    .map((id) => labelById.get(id) || `Grupo #${id}`)
    .join(', ');
}
